<div class="modal-header">
  <h4 class="modal-title">
    @switch (mode) {
      @case ('renewal-after-expired') {
        Групово обновяване
      }
      @case ('renewal-after-sold') {
        Групово копиране като нови
      }
      @case ('stop') {
        Групово спиране
      }
      @case ('delete') {
        Групово изтриване
      }
    }
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body" nzForceRepaint>
  @switch (mode) {
    @case ('renewal-after-expired') {
      <section class="mb-4 alert bg-primary-subtle">
        <p class="mb-2">
          Избраните обяви ще бъдат обновени с нова крайна дата, а цялата останала информация ще се запази без промяна.
        </p>
        <p class="m-0">
          Може да обновите избрани обяви или да изберете всички.
        </p>
      </section>
    }
    @case ('renewal-after-sold') {
      <section class="mb-4 alert bg-primary-subtle">
        <p class="mb-2">
          Избраните обяви ще бъдат копирани като нови обяви с нова крайна дата, а цялата останала информация ще бъде
          копирана от оригиналните.
        </p>
        <p class="m-0">
          Може да копирате избрани обяви или да изберете всички.
        </p>
      </section>
    }
    @case ('stop') {
      <section class="mb-4 alert alert-warning">
        <p class="mb-2">
          Избраните обяви ще бъдат маркирани като <strong>„Завършили без сделка“</strong> и ще бъдат скрити от
          останалите потребители.
        </p>
        <p class="m-0">
          Ще може да ги активирате отново по всяко време чрез опцията <strong>„Обновяване на обявата“</strong>.
        </p>
      </section>
    }
    @case ('delete') {
      <div class="alert alert-danger mb-4">
        <p class="mb-2">
          Избраните обяви ще бъдат изтрити окончателно и няма да има възможност да бъдат възстановени.
          Може да изтриете само избрани обяви или да изберете всички.
        </p>
        <p class="mb-0">
          <strong>Внимание:</strong> Това действие е необратимо.
        </p>
      </div>
    }
  }
  @if (mode === 'renewal-after-expired' || mode === 'renewal-after-sold') {
    <form [formGroup]="form">
      <div class="mb-3 row g-4">
        <div class="col-12 col-md-6">
          <label for="endDate" class="mb-0 form-label">Крайна дата и час*</label>
          <div class="input-group">
            <input
              ngbDatepicker
              id="endDate"
              name="endDate"
              formControlName="endDate"
              #endDatepicker="ngbDatepicker"
              placeholder="Изберете дата (дд.мм.гггг)"
              [minDate]="endDateMinDate"
              [maxDate]="endDateMaxDate"
              class="form-control rounded-start-1"
              [class.border-success]="endDate?.touched && endDate?.valid"
              [class.border-danger]="endDate?.touched && endDate?.invalid"/>
            <button
              type="button"
              [disabled]="endDatepicker.disabled"
              class="btn btn-outline-secondary"
              (click)="endDatepicker.toggle()">
              <i class="fa-regular fa-calendar-days"></i>
            </button>
          </div>
          @if (endDate?.touched && endDate?.invalid) {
            <small class="text-danger">Задължително поле във формат дд.мм.гггг!</small>
          }
        </div>
        <div class="col-6 col-md-3">
          <span class="form-label">Час*</span>
          <ng-select
            [clearable]="false"
            [searchable]="false"
            [items]="hourOptions"
            bindValue="value"
            bindLabel="label"
            formControlName="endHour"
            notFoundText="Няма намерени часове"
            placeholder="Изберете час"
            [class.is-valid]="endHour?.touched && endHour?.valid"
            [class.is-invalid]="endHour?.touched && endHour?.invalid">
          </ng-select>
          @if (endHour?.touched && endHour?.invalid) {
            <p class="m-0 invalid-feedback">Задължително поле!</p>
          }
        </div>
        <div class="col-6 col-md-3">
          <span class="form-label">Минути*</span>
          <ng-select
            [clearable]="false"
            [searchable]="false"
            [items]="minutesOptions"
            bindValue="value"
            bindLabel="label"
            formControlName="endMinutes"
            notFoundText="Няма намерени минути"
            placeholder="Изберете минути"
            [class.is-valid]="endMinutes?.touched && endMinutes?.valid"
            [class.is-invalid]="endMinutes?.touched && endMinutes?.invalid">
          </ng-select>
          @if (endMinutes?.touched && endMinutes?.invalid) {
            <p class="m-0 invalid-feedback">Задължително поле!</p>
          }
        </div>
      </div>
    </form>
  }
  @if (loadingData) {
    <div class="text-center">
      <h3>
        <i class="text-muted fa-solid fa-spinner fa-spin"></i>
      </h3>
      <h5 class="text-muted">Зареждане...</h5>
    </div>
  } @else {
    @if (ads.length === 0) {
      @switch (mode) {
        @case ('renewal-after-expired') {
          <h5 class="my-5 text-muted text-center">Не бяха намерени обяви, които могат да бъдат обновени.</h5>
        }
        @case ('renewal-after-sold') {
          <h5 class="my-5 text-muted text-center">Не бяха намерени обяви, които могат да бъдат копирани като нови.</h5>
        }
        @case ('stop') {
          <h5 class="my-5 text-muted text-center">Не бяха намерени обяви, които могат да бъдат спрени.</h5>
        }
        @case ('delete') {
          <h5 class="my-5 text-muted text-center">Не бяха намерени обяви, които могат да бъдат изтрити.</h5>
        }
      }
    } @else {
      <div class="mb-2 mt-4 d-flex">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="select-all"
            [checked]="areAllSelected()"
            (change)="toggleSelectAll($event)">
          <label for="select-all" class="form-check-label">
            Изберете всички
          </label>
        </div>
      </div>
      <ul class="list-unstyled">
        @for (ad of ads; track ad.adId) {
          <li class="mb-2 d-flex bg-light border rounded-3 cursor-pointer hover-shadow"
              (click)="toggleSelection(ad.adId)">
            <div class="my-auto ms-2 form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="checkbox-{{ ad.adId }}"
                [checked]="selectedAdIds.includes(ad.adId)">
            </div>
            <div class="d-flex bg-body-secondary">
              <div class="my-auto card-image">
                <nz-image [imageUrl]="environment.apiImageAdUrl + '/main/' + ad.adId"></nz-image>
              </div>
            </div>
            <div class="p-2">
              <div class="pb-2 lh-1 text-primary-emphasis">
                <i class="small text-secondary fa-solid "
                   [ngClass]="ad.adType === AdType.DirectSale ? 'fa-shopping-cart' : 'fa-gavel'">
                </i>
                {{ ad.adTitle }}
              </div>
              <div class="lh-1 small text-muted">Цена: {{ ad.adPrice.toFixed(2) }} лв.</div>
            </div>
          </li>
        }
      </ul>
    }
  }
</div>
<div class="modal-footer d-block text-end">
  <button
    type="button"
    class="me-2 btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    class="btn"
    (click)="onSubmit()"
    [class.btn-danger]="mode === 'delete'"
    [class.btn-warning]="mode === 'stop'"
    [class.btn-nz-primary]="mode === 'renewal-after-expired' || mode === 'renewal-after-sold'"
    [disabled]="loadingData || loadingSubmit || selectedAdIds.length === 0">
    @if (loadingSubmit) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    @switch (mode) {
      @case ('renewal-after-expired') {
        <span>Обнови</span>
      }
      @case ('renewal-after-sold') {
        <span>Копирай</span>
      }
      @case ('stop') {
        <span>Спири</span>
      }
      @case ('delete') {
        <span>Изтрий</span>
      }
    }
  </button>
</div>
